<template>
  <v-row>
    <v-col cols="12" class="mx-auto">
      <v-card class="elevation-0">
        <Paging 
          :resourceSettings="resourceSettings" 
          :resource="evaluations" 
          @loadResource="loadResource"
          @pageByNumber="pageByNumber" />
        <v-card-text>

          <v-row class="row">
            <v-col md="4" cols="12" FILTERS>
              <DateField 
                :modelValue="appointment_from_date" 
                label="Appointment from"
                @update:modelValue="(value) => { appointment_from_date = value; applyFilter() }"
                icon="calendar_today"
              />
            </v-col>
            <v-col md="4" cols="12" FILTERS>
              <DateField 
                :modelValue="appointment_to_date" 
                label="Appointment to"
                @update:modelValue="(value) => { appointment_to_date = value; applyFilter() }"
                icon="calendar_today"
              />
            </v-col>
            <v-col md="4" cols="12" FILTERS>
                <v-autocomplete
                  @change="applyFilter"
                  label="Status"
                  autocomplete="disabled"
                  outlined
                  dense
                  v-model="attended"
                  :items="statuses"
                  :class="`${arabic?'arFont':'enFont'}`"
                />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="1" class="mx-auto">
              <v-btn block @click.stop="$emit('openDialog', 'evaluation')" color="primary">
                {{ i18n.new }}
              </v-btn>
            </v-col>
          </v-row>
          <v-timeline v-if="evaluations.data &&  evaluations.data.length > 0" dense clipped>
            <v-timeline-item v-for="(evaluation, key) in evaluations.data" :key="`evaluation-${key}`" :color="evaluation.attended ? 'success' : 'red'" small>
              <v-row class="elevation-1 pa-4 py-2">
                <v-col cols="12">
                  <v-row class="align-center">
                    <v-col class="pa-0 col-auto">
                      <v-avatar size="40" color="primary">
                        <span class="white--text text-h5">{{ firstLettersName(evaluation.employee_name.name) }}</span>
                      </v-avatar>
                    </v-col>
                    <v-col>
                      <div style="font-size:11px;font-weight:700;">{{ i18n.employee }}</div>
                      <strong>{{ evaluation.employee_name.name }}</strong>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4" class="pa-0 mb-md-0 mb-3">
                      <div style="font-size:11px;font-weight:700;">{{ i18n.evaluation_appointment }}</div>
                      <div class="body-1">
                        <v-chip color="blue darken-1" dark small>
                          {{ formatDateToCurrentLocale(evaluation.appointment.appointment)[0] }}
                        </v-chip>
                        <v-chip color="blue darken-1" dark class="ml-2" small>
                          {{ formatDateToCurrentLocale(evaluation.appointment.appointment)[1] }}
                        </v-chip>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" class="pa-0 mb-md-0 mb-3">
                      <div style="font-size:11px;font-weight:700;">{{ i18n.evaluation_update_date }}</div>
                      <div class="body-1">{{ getFormat(evaluation.updated_at) }}</div>
                    </v-col>
                    <v-col cols="12" md="4" class="pa-0 mb-md-0 mb-3">
                      <div style="font-size:11px;font-weight:700;">{{ i18n.was_present }}</div>
                      <div class="body-1">{{ evaluation.attended ? i18n.yes : i18n.no }}</div>
                    </v-col>
                  </v-row>
                  <v-row v-if="evaluation.note" class="mt-md-2 ">
                    <v-col cols="12" class="pa-0">
                      <div style="font-size:11px;font-weight:700;">{{ i18n.evaluation_note }}</div>
                      <div class="body-1">
                        {{ evaluation.note }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-if="evaluation.result" class="mt-2">
                    <v-col col="12" class="pa-0">
                      <div class="mb-1">
                        <div style="font-size:11px;font-weight:700;">{{ i18n.evaluation_result }}</div>
                      </div>
                      <v-chip label small color="blue" dark>
                        {{ evaluation.result }}
                      </v-chip>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pa-0 pt-3">
                      <div>
                        <v-btn small @click.prevent="$emit('editResource', 'evaluation', evaluation)" class="mr-2" color="primary">Edit</v-btn>
                        <v-btn small @click.prevent="$emit('deleteResource', 'evaluation', evaluation)" color="error">Delete</v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
      </v-card>
    </v-col>  
  </v-row>
</template>

<script>
import { format } from 'timeago.js';
import Paging from '@/components/Paging'
import DateField from '@/components/partials/DateField'

export default {
  components: {Paging, DateField},
  props: ['evaluations', 'loading', 'resource'],
  data() {
    return {

      page: 1, 

      statuses: [
        {
          text: 'All',
          value: null,
        },
        {
          text: 'Attended',
          value: true,
        },
        {
          text: 'Not attended',
          value: false,
        },
      ],

      // @s filters
      appointment_from_date: null,
      appointment_to_date: null,
      attended: null,
      // @e filters

			resourceSettings: {
				resourceName: null,
				search: false,
				create: false,
				pagination: true,
			},
    }
  },
  computed: {
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
  },
  methods: {
    buildFilter() {
      let filter = ``

      if(this.appointment_from_date) {
        filter += `&appointment_from_date=${this.appointment_from_date}`
      }

      if(this.appointment_to_date) {
        filter += `&appointment_to_date=${this.appointment_to_date}`
      }

      if(this.attended != null) {
        filter += `&attended=${this.attended}`
      }

      return filter;
    },
    applyFilter() {
      this.loadResource()
    },
		getFormat(d){
			return format(d)
		},
		formatDateToCurrentLocale(date) {
			let new_date = (new Date(date))
			return [
				new_date.toLocaleDateString(this.arabic ? 'ar' : 'en', {
					day: 'numeric',
					year: 'numeric',
					month: 'short',
				}),
				new_date.toLocaleTimeString(this.arabic ? 'ar' : 'en'),
			]
		},
		firstLettersName(name) {
			const split_names = name.split(" ")

			if (split_names.length > 1) return (split_names[0][0] + split_names[1][0]).toUpperCase()
			
			return (split_names[0][0] + split_names[0][1]).toUpperCase()
		},
    loadResource() {
      this.$emit('loadResource', 'evaluations', 'evaluations', this.buildFilter(), this.page)
    },
    pageByNumber(page) {
      this.page = page 
      this.$emit('pageByNumber', 'evaluations', 'evaluations', page)
    },
  }
}
</script>